export default __webpack_public_path__ + "static/media/cta.1eec3b76.jpg";